module.exports = __webpack_public_path__ + "img/introduction_advert_01.cfbddc79.jpg";